const userAgent = '';
const path = '';
const host = '';
const protocol = '';
const queryParams = {};
const environment = '';

const MMT_HLD = {
  fromSEO: false, // this flag will help client to identify whether request is for SEO and is server rendered or not
  journeyId: '',
};
const isOnClient = (function f() {
  return typeof window !== 'undefined';
})();
class Cookies {
  cookies;

  constructor(cookies) {
    this.cookies = cookies || {};
  }

  setItem = (key, value) => {
    this.cookies[`${key}`] = value;
  };

  getItem = key => this.cookies[`${key}`];

  get = () => this.cookies;

  set = cookies => {
    this.cookies = cookies;
  };
}
module.exports = {
  userAgent,
  protocol,
  host,
  path,
  queryParams,
  MMT_HLD,
  isOnClient,
  cookies: new Cookies({}),
  environment,
};
